import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import rightWhatsapp from '../assets/img/whatsapp-icon.png';
import rightBrochure from '../assets/img/brochure-right-img.png';
import footerFacebook from '../assets/img/facebook-theme-icon.svg';
import footeryoutube from '../assets/img/youtube-theme-icon.svg';
import footerinstagram from '../assets/img/instagram-theme-icon.svg';
import downloadepdficon from '../assets/img/download-pdf-icon.svg';
import brochurePdf1 from '../assets/img/pdf/elixir-brochur.pdf';
import brochurePdf2 from '../assets/img/pdf/elixir-printing.pdf';
import brochurePdf3 from '../assets/img/pdf/elixir-arsign.pdf';
import brochurePdf4 from '../assets/img/pdf/elixir-label.pdf';
import brochurePdf5 from '../assets/img/pdf/elixir-exhibitions.pdf';
import brochurePdf6 from '../assets/img/pdf/elixir-signages.pdf';
import brochurePdf7 from '../assets/img/pdf/elixir-safety.pdf';
import brochurePdf8 from '../assets/img/pdf/elixir-packaging.pdf';
import brochurePdf9 from '../assets/img/pdf/elixir-gifts.pdf';
import brochurePdf10 from '../assets/img/pdf/elixir-restaurant.pdf';
import brochurePdf11 from '../assets/img/pdf/elixir-digital-signages.pdf';


function Footer() {
  return (
    <>    
    <section className="rightBrochure">
      <a href="#downloadBrochures" rel="noopener noreferrer">
        <img src={rightBrochure} className="img-fluid" alt="elixir" />
      </a>
    </section>
    <section className="rightWhatsapp">
      <Link to="https://wa.me/966552301809?text=Hello%2C%20I%27d%20like%20to%20chat!" target="_blank" rel="noopener noreferrer">
        <img src={rightWhatsapp} className="img-fluid" alt="elixir" />
      </Link>
    </section>
    <footer>
    <Container>
      <Row>        
        <div className="brocureBox brocureBox-mobile" id="downloadBrochures">
          <h3>Download Brochure</h3>
          <a href={brochurePdf1} className="brocureBox-file" target="_blank">
            <div className="brocureBox-img">
              <img src={require('../assets/img/elixir-brochur-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
              <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
            </div>
            <h4>Brochur</h4>
          </a>
          <a href={brochurePdf2} className="brocureBox-file" target="_blank">
            <div className="brocureBox-img">
              <img src={require('../assets/img/elixir-printing-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
              <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
            </div>
            <h4>Printing</h4>
          </a>
          <a href={brochurePdf3} className="brocureBox-file" target="_blank">
            <div className="brocureBox-img">
              <img src={require('../assets/img/elixir-arsign-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
              <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
            </div>
            <h4>AR Sign</h4>
          </a>    
          <a href={brochurePdf4} className="brocureBox-file" target="_blank">
            <div className="brocureBox-img">
              <img src={require('../assets/img/elixir-label-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
              <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
            </div>
            <h4>Label</h4>
          </a>        
          <a href={brochurePdf5} className="brocureBox-file" target="_blank">
            <div className="brocureBox-img">
              <img src={require('../assets/img/elixir-exhibitions-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
              <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
            </div>
            <h4>Exhibitions</h4>
          </a>
          <a href={brochurePdf6} className="brocureBox-file" target="_blank">
            <div className="brocureBox-img">
              <img src={require('../assets/img/elixir-signages-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
              <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
            </div>
            <h4>Signages</h4>
          </a>  
          <a href={brochurePdf7} className="brocureBox-file" target="_blank">
            <div className="brocureBox-img">
              <img src={require('../assets/img/elixir-safety-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
              <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
            </div>
            <h4>Safety</h4>
          </a>
          <a href={brochurePdf8} className="brocureBox-file" target="_blank">
            <div className="brocureBox-img">
              <img src={require('../assets/img/elixir-packaging-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
              <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
            </div>
            <h4>Packaging</h4>
          </a>
          <a href={brochurePdf9} className="brocureBox-file" target="_blank">
            <div className="brocureBox-img">
              <img src={require('../assets/img/elixir-gifts-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
              <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
            </div>
            <h4>Gifts</h4>
          </a>
          <a href={brochurePdf10} className="brocureBox-file" target="_blank">
            <div className="brocureBox-img">
              <img src={require('../assets/img/elixir-restaurant-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
              <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
            </div>
            <h4>Restaurant</h4>
          </a>
          <a href={brochurePdf11} className="brocureBox-file" target="_blank">
            <div className="brocureBox-img">
              <img src={require('../assets/img/elixir-digital-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
              <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
            </div>
            <h4>Digital</h4>
          </a>
        </div>
      </Row>
      <Row>
        <Col lg="3" md={3}>
          <div className="footerLink">
            <h4><span>Links</span></h4>
            <Link to="/Aboutus">About</Link>
            <Link to="/ITsolutions">IT Solutions</Link>
            <Link to="/Clients">Clients</Link>
            <Link to="/Jobs">Jobs</Link>
            <Link to="/Contact">Contact</Link>
            <Link to="/Privacypolicy">Privacy Policy</Link>
          </div>
        </Col>
        <Col lg="6" md={9}>
          <Row>
          <Col md={12}>
            <div className="footerLink">  
              <h4><span>Sales</span></h4>
            </div>
          </Col>
          <Col md={6}>
            <div className="footerAddr">    
              <h5>SAUDI ARABIA</h5>
              <p>Mobile: <Link to="tel:+966552301809">+966 55 230 1809</Link></p>  
            </div>     
          </Col>
          <Col md={6}>
            <div className="footerAddr mb-3">    
              <h5>INDIA</h5>
              <p>Mobile: <Link to="tel:+9163851 10628">+91 63851 10628</Link></p>  
            </div>        
          </Col>
          <Col md={12}>
            <div className="footerLink">  
              <h4><span>Locations</span></h4>
            </div>
          </Col>
            <Col md={6}>
              <div className="footerAddr">    
                <h5>SAUDI ARABIA</h5>            
                <p>P.O.Box:2834, Alkhobar 31952,</p>
                <p>Dammam 31463, Saudi Arabia.</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="footerAddr">    
                <h5>INDIA</h5>            
                <p>139 A, Velachery Road,</p>
                <p>Little Mount, Chennai - 600015.</p>
              </div>
            </Col>
          </Row>
        </Col>
        <Col lg="3" md={12}>
          <div className="footerSocial">
            <h4><span>Support</span></h4>
            <Link to="https://www.facebook.com/people/ElixirWorldWide/100069599795667/" target="_blank">
              <img src={footerFacebook} className="img-fluid" alt="elixir" />
            </Link>
            {/* <Link to="https://x.com/i/flow/login?redirect_after_login=%2Felixirworldwide" target="_blank">
              <img src={footertwitter} className="img-fluid" alt="elixir" />
            </Link> */}
            <Link to="/" target="_blank">
              <img src={footerinstagram} className="img-fluid" alt="elixir" />
            </Link>
            <Link to="https://www.youtube.com/elixirworldwide" target="_blank">
              <img src={footeryoutube} className="img-fluid" alt="elixir" />
            </Link>
            <p><span>Enquiry:</span> <Link to="mailto:anand@elixirworldwide.com">anand@elixirworldwide.com</Link></p>
            <p><span>Mail:</span> <Link to="mailto:elixirworldwide@gmail.com">elixirworldwide@gmail.com</Link></p>
            <img src={require('../assets/img/iso-bureau-img.png')} className="img-fluid isofooterLogo" alt="elixir" />  
            <p className="footerCopyright">© ELIXIR Advertising & AR Graphics</p>               
          </div>
        </Col>        
      </Row>  
    </Container>
    </footer>       
    </>
  );
}

export default Footer;
